import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import parse from 'html-react-parser'
import { RichTextWidget as RichTextWidgetType } from 'schemas/RichTextWidgetSchema'
import { Widget } from 'features/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import PlaceHolder from 'components/share/PlaceHolder'
import StyledRichTextContent from './index.css'

const RichTextWidget: Widget = ({ widgetId }) => {
  const theme = useDisplayTheme()
  const widgetSetting = useDashboardWidgetSetting<RichTextWidgetType>(widgetId)

  const contents = widgetSetting.text ? parse(widgetSetting.text) : ''

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <StyledRichTextContent displayTheme={theme}>{contents}</StyledRichTextContent>
    </ErrorBoundary>
  )
}

export default RichTextWidget
